import { useState } from 'react';
import { FLOOR_PLANS_LAYOUT } from '../constants';
import SvgData from 'assets/json/paths.json';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import { BuildingHoverCard } from 'components/BuildingRotate/components/BuildingHoverCard';
import { useTranslation } from 'react-i18next';

// const adapter = {
//   'vic-1.1': 'vic-1',
//   'vic-1.2': 'vic-2',
//   'vic-1.3': 'vic-3',
//   'vic-2.1': 'vic-1',
//   'vic-2.2': 'vic-2',
//   'vic-2.3': 'vic-3',
// };

export const FloorPlan = ({
  onShow,
  selectedBuilding,
  selectedFloor,
  selectedSegment,
  clickedApartment,
  setClickedApartment,
}) => {
  const { t } = useTranslation();
  const image = FLOOR_PLANS_LAYOUT[selectedBuilding]?.image;
  const { mapFloors, apartmentTemplates } = SvgData;
  const apartments = mapFloors;

  const [hoveredData, setHoveredData] = useState({
    isHovering: false,
    event: null,
  });

  // const handleMouseEnter = (event, templateId) => {
  //   if (!isDesktop) return;

  //   const target = event.currentTarget;
  //   const rect = target.getBoundingClientRect();
  //   const data = apartmentTemplates[templateId];

  //   setHoveredData({
  //     position: {
  //       x: rect.left + rect.width + 16,
  //       y: rect.top,
  //     },
  //     data,
  //     isOpen: true,
  //   });
  // };

  // const handleMouseLeave = () => {
  //   if (!isDesktop) return;
  //   setHoveredData({ position: null, data: null, isOpen: false });
  // };

  const onPathClick = (id) => {
    onShow(apartmentTemplates[id]);
  };

  return (
    <>
      <div className="floor-plan-layout">
        <div className="layout-title">
          <p>
            <span>{t('typical_floor_plans')}</span>
            <br />
            <span className="bold">
              Vizion Horizon | VIZ{' '}
              <span className="number">
                {selectedBuilding === 'viz-1' ? '-1' : '-2'}
              </span>
            </span>
          </p>
        </div>
        <TransformWrapper centerZoomedOut disablePadding wheel={{ step: 0.02 }}>
          <TransformComponent>
            <div className={`floor-plan-container`}>
              <img
                src={image}
                alt={`Bản vẽ mặt bằng của ${selectedBuilding}-${selectedSegment}-${selectedFloor}`}
              />
              <svg
                width="3778"
                height="2366"
                viewBox="0 0 3778 2366"
                xmlns="http://www.w3.org/2000/svg"
                className={`${selectedBuilding === 'viz-1' ? 'scale-fix' : ''}`}
              >
                {apartments.map(({ templateId, mapPath }) => {
                  const template = apartmentTemplates[templateId];
                  if (!template) return null;

                  const { type, wallArea, usageArea } = template;

                  return (
                    <g key={templateId} className="path-group">
                      {mapPath.map((pathData, index) => {
                        const isClicked =
                          clickedApartment &&
                          clickedApartment.templateId === templateId &&
                          clickedApartment.pathData === pathData;

                        return (
                          <path
                            key={`${templateId}-path-${index}`}
                            id={`${templateId}-path-${pathData}`}
                            d={pathData}
                            data-wall-area={wallArea}
                            data-usage-area={usageArea}
                            data-type={type}
                            fill={'transparent'}
                            stroke={'transparent'}
                            strokeWidth={3}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className={isClicked ? 'clicked' : ''}
                            onMouseEnter={(event) => {
                              setHoveredData({ isHovering: true, event });
                            }}
                            onMouseLeave={() =>
                              setHoveredData({
                                isHovering: false,
                                event: null,
                              })
                            }
                            onClick={() => {
                              setClickedApartment({ templateId, pathData });
                              onPathClick(templateId);
                            }}
                          />
                        );
                      })}
                    </g>
                  );
                })}
              </svg>

              {/* Tooltip detail for desktop - same as ImageSlider */}
            </div>
          </TransformComponent>
        </TransformWrapper>
      </div>
      {hoveredData.isHovering && (
        <BuildingHoverCard event={hoveredData.event} />
      )}
    </>
  );
};

// const HoveredTooltip = ({ position, data }) => {
//   if (!position) return null;

//   const { type, usageArea, wallArea } = data;
//   const { label, wc, mini } = APARTMENT_ADAPTER[type];
//   const isYOverflowing = position.y + 300 > window.innerHeight;
//   const isXOverflowing = position.x + 300 > window.innerWidth;
//   const positionStyle = {
//     left: isXOverflowing ? position.x - 320 : position.x,
//     top: isYOverflowing ? position.y - 175 : position.y,
//   };

//   return (
//     <div className="tooltip-desktop" style={positionStyle}>
//       <div className="image">
//         <img src={mini} alt="Căn hộ" />
//       </div>
//       <div className="tooltip-body">
//         <p className="title">{label}</p>
//         <ul className="list">
//           <li className="list-item">
//             <CheckCircle />
//             <span className="text">WC</span>
//             <span>{wc}</span>
//           </li>
//           <li className="list-item">
//             <CheckCircle />
//             <span className="text">DT thông thuỷ</span>
//             <span>{usageArea}m2</span>
//           </li>
//           <li className="list-item">
//             <CheckCircle />
//             <span className="text">DT tim tường</span>
//             <span>{wallArea}m2</span>
//           </li>
//         </ul>
//       </div>
//       <button className="more-btn">Tìm hiểu thêm</button>
//     </div>
//   );
// };
